export default __webpack_public_path__ + "static/media/Shevchuk.6b4f5a3d.png";